import { camelCase, groupBy, map, mapValues } from "lodash";
import { textCamelCase } from "./string.utils";
import { useSelector } from "react-redux";

export function useAppPermissions() {
  const { user } = useSelector((state) => state.auth);
  const appPermissions = user?.app_permissions?.length ? user.app_permissions : [];
  const userPermissions = user?.permissions?.length ? user.permissions : [];

  const groupedPermissions = groupBy(userPermissions, (permission) =>
    textCamelCase(permission?.split(":")[0])
  );

  const permissionObject = mapValues(groupedPermissions, (permissions) => {
    let newPermissions = {};
    appPermissions.forEach((appPermission) => {
      newPermissions[camelCase(appPermission)] = map(
        permissions,
        (perm) => perm.split(":")[1]
      ).includes(appPermission);
    });

    return newPermissions;
  });

  return permissionObject;
}

const myApplication = {
  name: "Aurobil Cars",
  slugan: "Trusted Car Sales Center",
  email: "aurobilcars@gmail.com",
  address: "Ka-71 Pragati Sarani, Dhaka-1212",
  mobile: "(+88) 01911 88 77 31",
  googleMap: "https://maps.app.goo.gl/9ChvCD8P13aVnSXTA"
};

export function getMyApplication() {
  return myApplication;
}
